module.exports = __webpack_public_path__ + "static/img/sy_tu1.2ac835f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/sy_tu1.png
// module id = pbQ6
// module chunks = 1